"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PULL_PANEL_TRANSITION_DURATION = void 0;
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var react_dom_1 = tslib_1.__importDefault(require("react-dom"));
var docs_soft_keyboard_1 = require("@tencent/docs-soft-keyboard");
var phy_touch_1 = tslib_1.__importDefault(require("phy-touch"));
var css3transform_1 = tslib_1.__importDefault(require("css3transform"));
var docs_user_agent_1 = tslib_1.__importDefault(require("@tencent/docs-user-agent"));
var interface_1 = require("./interface");
var keepDom_1 = require("../../utils/keepDom");
var helper_1 = require("../../utils/helper");
var theme_1 = require("../../utils/theme");
var preventScrollPenetrate_1 = require("../../utils/preventScrollPenetrate");
var stylusAdapter_1 = require("../../utils/stylusAdapter");
var locale_1 = require("../../common/locale");
exports.PULL_PANEL_TRANSITION_DURATION = 300;
var TRIGGER_STAGE_SWITCH_GAP = 40;
var HALF_PANEL_RATIO = 0.5;
var FULL_PANEL_RATIO = 0.8;
var BIG_HEADER_HEIGHT = 72;
var SMALL_HEADER_HEIGHT = 56;
var SINGLE_STAGE_PANEL_MARGIN = 24;
var PullPanel = (function (_super) {
    tslib_1.__extends(PullPanel, _super);
    function PullPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.panelRef = React.createRef();
        _this.headerRef = React.createRef();
        _this.maskRef = React.createRef();
        _this.contentRef = React.createRef();
        _this.fixedContentRef = React.createRef();
        _this.inShowAnimation = false;
        _this.softKeyboard = null;
        _this.keyboardTranslate = 0;
        _this.state = {
            pullStage: interface_1.PullStage.HALF,
        };
        _this.handleClickMask = function () {
            if (_this.props.maskClosable && !_this.inShowAnimation) {
                _this.requestHide();
            }
        };
        _this.handleMoveStop = function () {
            var _a = _this.props, visible = _a.visible, pullable = _a.pullable;
            if (!visible || !pullable || !_this.touch) {
                return;
            }
            if (_this.hasMultiplePullStages) {
                _this.handleMultiStageMoveStop();
                return;
            }
            if (_this.currentValue > TRIGGER_STAGE_SWITCH_GAP) {
                _this.requestHide();
            }
            else {
                _this.scrollToShowPosition();
            }
        };
        _this.preventDefault = function (e) {
            e.preventDefault();
        };
        _this.handleOrientationChange = function () {
            var handler = function () {
                var _a = _this.defaultHeights, panelMaxHeight = _a.panelMaxHeight, showTranslate = _a.showTranslate;
                var visible = _this.props.visible;
                if (_this.touch) {
                    _this.touch.max = panelMaxHeight;
                }
                if (visible) {
                    _this.currentValue = showTranslate;
                    if (_this.hasMultiplePullStages) {
                        _this.switchPullStage(interface_1.PullStage.FULL);
                        return;
                    }
                }
                _this.forceUpdate();
            };
            if (docs_user_agent_1.default.isIOS) {
                setTimeout(handler, 0);
            }
            else {
                handler();
            }
        };
        _this.handleKeyboardHeightChange = function (keyboard) {
            var _a;
            if (!_this.props.visible) {
                _this.keyboardTranslate = 0;
                return;
            }
            var heightInViewport = keyboard.heightInViewport;
            var input = document.activeElement;
            if (input
                && heightInViewport > 0
                && ((_a = _this.panelRef.current) === null || _a === void 0 ? void 0 : _a.contains(input))
                && window.innerHeight - input.getBoundingClientRect().bottom < heightInViewport) {
                _this.keyboardTranslate = heightInViewport;
            }
            else {
                _this.keyboardTranslate = 0;
            }
            _this.scrollToShowPosition();
        };
        _this.themedRender = function (classNames) {
            var _a, _b, _c;
            var _d = _this.props, prefixCls = _d.prefixCls, className = _d.className, style = _d.style, children = _d.children, visible = _d.visible, pullable = _d.pullable, containerStyle = _d.containerStyle, contentStyle = _d.contentStyle, zIndex = _d.zIndex, destroyOnClose = _d.destroyOnClose, containerClassName = _d.containerClassName, contentClassName = _d.contentClassName, content = _d.content, fixedContent = _d.fixedContent;
            var classes = classNames(prefixCls, className, (_a = {},
                _a[prefixCls + "-pullable"] = pullable,
                _a));
            var maskClasses = classNames(prefixCls + "-mask", (_b = {},
                _b[prefixCls + "-mask-hidden"] = !_this.isMaskVisible,
                _b));
            var containerClasses = classNames(prefixCls + "-container", containerClassName, (_c = {},
                _c[prefixCls + "-container-hidden"] = !visible,
                _c));
            var renderedChildren = children || content;
            if (destroyOnClose && !keepDom_1.decideKeepDom.call(_this, exports.PULL_PANEL_TRANSITION_DURATION, visible)) {
                renderedChildren = null;
            }
            var _e = _this.getHeightRelatedStyle(), panelHeightStyle = _e.panelHeightStyle, contentHeightStyle = _e.contentHeightStyle;
            return react_dom_1.default.createPortal(h("div", { className: containerClasses, style: tslib_1.__assign({ zIndex: zIndex }, containerStyle) },
                h("div", { className: maskClasses, onClick: _this.handleClickMask, ref: _this.maskRef }),
                h("div", { className: classes, style: tslib_1.__assign(tslib_1.__assign({}, panelHeightStyle), style), ref: _this.panelRef },
                    _this.renderHeader(classNames),
                    h("div", { className: classNames(prefixCls + "-content", contentClassName), style: tslib_1.__assign(tslib_1.__assign({}, contentHeightStyle), contentStyle), ref: _this.contentRef }, renderedChildren)),
                _this.shouldRenderFixedContent &&
                    h("div", { className: classNames(prefixCls + "-fixed-content"), ref: _this.fixedContentRef }, fixedContent)), document.body);
        };
        return _this;
    }
    Object.defineProperty(PullPanel.prototype, "currentValue", {
        get: function () {
            var touch = this.touch;
            return touch.target[touch.property];
        },
        set: function (value) {
            var touch = this.touch;
            touch.target[touch.property] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PullPanel.prototype, "minValue", {
        get: function () {
            return 0 - this.keyboardTranslate;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PullPanel.prototype, "hasMultiplePullStages", {
        get: function () {
            return this.props.pullable && this.props.pullStages === 'multiple';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PullPanel.prototype, "canPullHeaderOnly", {
        get: function () {
            return this.hasMultiplePullStages || this.props.pullHeaderOnly;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PullPanel.prototype, "shouldRenderFixedContent", {
        get: function () {
            return this.props.fixedContent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PullPanel.prototype, "defaultHeights", {
        get: function () {
            var panelMaxHeight = this.hasMultiplePullStages
                ? window.innerHeight * FULL_PANEL_RATIO
                : window.innerHeight - SINGLE_STAGE_PANEL_MARGIN;
            var panelHalfHeight = window.innerHeight * HALF_PANEL_RATIO;
            var showTranslate = this.minValue;
            return {
                panelHalfHeight: panelHalfHeight,
                panelMaxHeight: panelMaxHeight,
                showTranslate: showTranslate
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PullPanel.prototype, "multipleStageHeights", {
        get: function () {
            var _a = this.defaultHeights, panelHalfHeight = _a.panelHalfHeight, panelFullHeight = _a.panelMaxHeight, showTranslate = _a.showTranslate;
            var fullTranslate = showTranslate;
            var halfTranslate = panelFullHeight - panelHalfHeight - this.keyboardTranslate;
            var headerDom = this.headerRef.current;
            var headerHeight = headerDom
                ? headerDom.clientHeight
                : (this.props.pullable ? BIG_HEADER_HEIGHT : SMALL_HEADER_HEIGHT);
            var contentLimitedHeight = panelHalfHeight - headerHeight;
            return {
                panelHalfHeight: panelHalfHeight,
                panelFullHeight: panelFullHeight,
                pullStageTranslates: [halfTranslate, fullTranslate],
                contentLimitedHeight: contentLimitedHeight,
                headerHeight: headerHeight,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PullPanel.prototype, "isMaskVisible", {
        get: function () {
            var _a = this.props, mask = _a.mask, visible = _a.visible, pullable = _a.pullable, pullStages = _a.pullStages;
            if (!visible) {
                return false;
            }
            if (typeof mask === 'boolean') {
                return mask;
            }
            return pullable && pullStages === 'single';
        },
        enumerable: false,
        configurable: true
    });
    PullPanel.prototype.getHeightRelatedStyle = function () {
        var _a;
        var fixedContentHeight;
        if (this.shouldRenderFixedContent) {
            fixedContentHeight = (_a = this.fixedContentRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight;
        }
        if (this.hasMultiplePullStages) {
            var pullStage = this.state.pullStage;
            var _b = this.multipleStageHeights, contentLimitedHeight = _b.contentLimitedHeight, panelFullHeight = _b.panelFullHeight;
            return {
                contentHeightStyle: {
                    maxHeight: pullStage === interface_1.PullStage.FULL ? undefined : contentLimitedHeight,
                    paddingBottom: fixedContentHeight,
                },
                panelHeightStyle: {
                    height: panelFullHeight,
                },
            };
        }
        var _c = this.defaultHeights, panelMaxHeight = _c.panelMaxHeight, panelHalfHeight = _c.panelHalfHeight;
        var _d = this.props, panelHeight = _d.panelHeight, pullable = _d.pullable;
        return {
            contentHeightStyle: {
                paddingBottom: fixedContentHeight,
            },
            panelHeightStyle: {
                maxHeight: panelMaxHeight,
                height: panelHeight || (pullable ? undefined : panelHalfHeight),
            }
        };
    };
    PullPanel.prototype.moveTo = function (destination, callback, needAnimation) {
        if (needAnimation === void 0) { needAnimation = true; }
        var touch = this.touch;
        touch.stop();
        touch._preventMove = true;
        touch.to(destination, needAnimation ? exports.PULL_PANEL_TRANSITION_DURATION : 0, undefined, function () {
            touch._preventMove = false;
            callback && callback();
        });
    };
    PullPanel.prototype.scrollToHidePosition = function (callback) {
        var panelDom = this.panelRef.current;
        if (!panelDom) {
            return;
        }
        this.moveTo(panelDom.clientHeight, callback);
    };
    PullPanel.prototype.scrollToShowPosition = function (callback, needAnimation) {
        var _this = this;
        if (needAnimation === void 0) { needAnimation = true; }
        var targetTranslate = this.hasMultiplePullStages ? this.multipleStageHeights.pullStageTranslates[interface_1.PullStage.HALF]
            : this.defaultHeights.showTranslate;
        var moveEndTranslate = this.currentValue;
        if (moveEndTranslate === targetTranslate) {
            return;
        }
        if (this.hasMultiplePullStages) {
            this.setState({ pullStage: interface_1.PullStage.HALF });
        }
        this.inShowAnimation = true;
        this.moveTo(targetTranslate, function () {
            _this.inShowAnimation = false;
            callback && callback();
        }, needAnimation);
    };
    PullPanel.prototype.requestHide = function () {
        var _a = this.props, onCancel = _a.onCancel, onOk = _a.onOk, onClose = _a.onClose;
        (onClose || onCancel || onOk)();
    };
    PullPanel.prototype.handleMultiStageMoveStop = function () {
        var moveStartStage = this.state.pullStage;
        var moveEndTranslate = this.currentValue;
        var _a = this.multipleStageHeights.pullStageTranslates, halfTranslate = _a[0], fullTranslate = _a[1];
        if (moveEndTranslate > halfTranslate + TRIGGER_STAGE_SWITCH_GAP) {
            return this.requestHide();
        }
        if (moveStartStage === interface_1.PullStage.FULL) {
            if (moveEndTranslate === fullTranslate) {
                return;
            }
            if (moveEndTranslate > fullTranslate + TRIGGER_STAGE_SWITCH_GAP) {
                return this.switchPullStage(interface_1.PullStage.HALF);
            }
            return this.switchPullStage(interface_1.PullStage.FULL);
        }
        if (moveStartStage === interface_1.PullStage.HALF) {
            if (moveEndTranslate === halfTranslate) {
                return;
            }
            if (moveEndTranslate < halfTranslate - TRIGGER_STAGE_SWITCH_GAP) {
                return this.switchPullStage(interface_1.PullStage.FULL);
            }
            return this.switchPullStage(interface_1.PullStage.HALF);
        }
    };
    PullPanel.prototype.switchPullStage = function (pullStage) {
        if (!this.hasMultiplePullStages) {
            return;
        }
        this.setState({ pullStage: pullStage });
        var pullStageTranslates = this.multipleStageHeights.pullStageTranslates;
        var translate = pullStageTranslates[pullStage];
        this.moveTo(translate);
    };
    PullPanel.prototype.initKeyboardDetection = function () {
        this.clearKeyboardDetection();
        this.softKeyboard = new docs_soft_keyboard_1.SoftKeyboard();
        this.softKeyboard.on('change', this.handleKeyboardHeightChange);
    };
    PullPanel.prototype.clearKeyboardDetection = function () {
        var _a;
        (_a = this.softKeyboard) === null || _a === void 0 ? void 0 : _a.dispose();
        this.keyboardTranslate = 0;
    };
    PullPanel.prototype.componentDidMount = function () {
        var _this = this;
        var panelDom = this.panelRef.current;
        css3transform_1.default(panelDom);
        this.maskRef.current.addEventListener('touchmove', this.preventDefault);
        window.addEventListener('resize', this.handleOrientationChange);
        var _a = this.props, visible = _a.visible, pullable = _a.pullable, animateOnMount = _a.animateOnMount, enableKeyboardDetection = _a.enableKeyboardDetection, preventScrollPenetrate = _a.preventScrollPenetrate;
        if (enableKeyboardDetection) {
            this.initKeyboardDetection();
        }
        this.touch = new phy_touch_1.default({
            touch: this.canPullHeaderOnly ? this.headerRef.current : panelDom,
            target: panelDom,
            property: 'translateY',
            max: this.defaultHeights.panelMaxHeight,
            min: 0,
            value: panelDom.clientHeight,
            touchEnd: this.handleMoveStop,
            touchCancel: this.handleMoveStop,
            animationEnd: this.handleMoveStop,
            fixed: !pullable,
            shouldRebound: function () { return _this.props.visible; },
            bindSelf: true,
            preventDefault: this.canPullHeaderOnly,
        });
        Object.defineProperty(this.touch, 'min', { get: function () { return _this.minValue; } });
        if (visible) {
            this.scrollToShowPosition(function () { return _this.shouldRenderFixedContent && !_this.hasMultiplePullStages && _this.forceUpdate(); }, animateOnMount);
        }
        if (preventScrollPenetrate) {
            preventScrollPenetrate_1.preventSelfScrollPenetrate({
                container: this.contentRef.current,
                direction: 'y',
                stopPropagationBorder: 'upper',
            });
        }
    };
    PullPanel.prototype.componentWillUnmount = function () {
        this.maskRef.current.removeEventListener('touchmove', this.preventDefault);
        window.removeEventListener('resize', this.handleOrientationChange);
        this.touch = null;
        this.clearKeyboardDetection();
    };
    PullPanel.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (prevProps.visible && !this.props.visible) {
            return this.scrollToHidePosition(function () {
                _this.touch && (_this.touch._preventMove = true);
            });
        }
        if (!prevProps.visible && this.props.visible) {
            return this.scrollToShowPosition(function () {
                _this.touch._preventMove = false;
            });
        }
        if (!prevProps.enableKeyboardDetection && this.props.enableKeyboardDetection) {
            this.initKeyboardDetection();
        }
        if (prevProps.enableKeyboardDetection && !this.props.enableKeyboardDetection) {
            this.clearKeyboardDetection();
        }
    };
    PullPanel.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    PullPanel.prototype.renderHeader = function (classNames) {
        var _a, _b;
        var _c = this.props, prefixCls = _c.prefixCls, okText = _c.okText, onOk = _c.onOk, title = _c.title, headerStyle = _c.headerStyle, cancelText = _c.cancelText, onCancel = _c.onCancel, header = _c.header, description = _c.description, showHeaderBorder = _c.showHeaderBorder, headerSize = _c.headerSize, headerClassName = _c.headerClassName;
        var headerPostfix = description ? 'with-desc' : headerSize;
        var headerClasses = classNames(prefixCls + "-header", prefixCls + "-header-" + headerPostfix, headerClassName, (_a = {},
            _a[prefixCls + "-header-show-border"] = showHeaderBorder,
            _a));
        var titleClassName = classNames(prefixCls + "-header-title", (_b = {},
            _b[prefixCls + "-header-title-with-desc"] = description,
            _b[prefixCls + "-header-title-centered"] = cancelText && okText,
            _b));
        return (h("div", { className: headerClasses, ref: this.headerRef, style: headerStyle }, header ?
            header
            : h(React.Fragment, null,
                cancelText &&
                    h(stylusAdapter_1.WithStylusClick, { clickHandler: onCancel },
                        h("span", { className: classNames(prefixCls + "-header-cancel") }, cancelText)),
                h("span", { className: titleClassName },
                    h("span", null, title),
                    description && h("span", { className: classNames(prefixCls + "-header-desc") }, description)),
                okText &&
                    h(stylusAdapter_1.WithStylusClick, { clickHandler: onOk },
                        h("span", { className: classNames(prefixCls + "-header-ok") }, okText)))));
    };
    return PullPanel;
}(React.Component));
exports.default = PullPanel;
PullPanel.defaultProps = {
    prefixCls: 'dui-m-pullpanel',
    title: locale_1.i18n('title'),
    okText: locale_1.i18n('done'),
    cancelText: '',
    onOk: helper_1.emptyFn,
    destroyOnClose: false,
    pullable: true,
    animateOnMount: true,
    showHeaderBorder: true,
    headerSize: 'big',
    enableKeyboardDetection: false,
    maskClosable: true,
    preventScrollPenetrate: true,
    pullStages: 'single',
};
